import Passengers from "./Passengers.vue";
export default Passengers;
